import {SiteadminController} from "SiteadminController";
import l10n from 'diy/util/l10n';
// import features = require('diy/util/features');
import $ = require('jquery');
// let api = require<any>('../api');
// import globalEvents = require('diy/util/globalEvents');

class Controller implements SiteadminController {

    private controllerLoaded = false;

    private eofNotice = $(`
<div class="sbh-eof-notice">
    <span class="sbh-eof-notice-icon">&#160;</span>
    <span class="sbh-eof-notice-text">` + l10n('sbh.eofNotice') + `</span>
</div>`
    );

    afterFillContent(el: HTMLElement, response: any, contentElement: JQuery) {
        //do nothing
    };

    allowSwitch() {
        return this.controllerLoaded;
    };

    show() {
        $('div.cc-sa-controller-fbpb main').prepend(this.eofNotice);
        if ($('div.cc-sa-controller-fbpb main .sbh-eof-notice').length === 1) {
            $('div.cc-sa-controller-fbpb main iframe')[0].style.height =
                ($('div.cc-sa-controller-fbpb main iframe')[0].clientHeight -
                    $('div.cc-sa-controller-fbpb main .sbh-eof-notice')[0].clientHeight) + 'px';
        }
    };

    hide() {
        //do nothing
    };

    getWindowSize() {
        return {
            width: 817,
            height: 585,
        };
    }
}

let controllerInstance = new Controller();
export = controllerInstance;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/main/controllers/fbpb.ts
 **/